import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as app_consts from "../../../constants/react_app_consts";
import PageHeading from "../components/page_heading/PageHeading";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import WizardComp from "../components/wizard/WizardComp";
import { useLocation, useParams } from "react-router";
import { useDispatch } from "react-redux";

import { Modal, ModalBody, ModalHeader, Button, Alert } from "reactstrap";
import WeighbridgeTicketSelector from "../weighbridge/WeighbridgeTicketSelector";
import SelectedWeighbridgeTicketCard from "../weighbridge/SelectedWeighbridgeTicketCard";

import {
  RETRIEVE_ALL_WEIGH_BRIDGE_TICKETS_API,
  RETRIEVE_WEIGH_BRIDGE_TICKET_DETAILS_API,
} from "../../../api/api_data";
import { makeEmployeeDashboardApiRequest } from "../../../api/api_helper";
import AuthLoader from "../../components/page_messaging/AuthLoader";
import { getLastWeighbridgeSyncMeta } from "../../../services/weighbridge_sync_service";
import { success_sign_out_modal } from "../../../reducers/dashboard_reducers/auth/sign_out_modal_Slice";
import {
  resolveWeighbridgeTicketRecord,
  resolveWeighbridgeTicketPrefillData,
  resolveWeighbridgeUsageStatus,
  sortWeighbridgeTicketsDesc,
} from "../../../utils/weighbridgeTicketNormalization";

const normalizeWeighbridgeTickets = (rows = []) => {
  return rows.map((item, index) => {
    const { ticket, ticketStatus, ticketType, backendTicketId } =
      resolveWeighbridgeTicketRecord(item);
    const prefillData = resolveWeighbridgeTicketPrefillData(item);

    return {
      id:
        backendTicketId ||
        prefillData?.weighbridge_ticket_id ||
        prefillData?.weigh_bridge_ticket_number ||
        prefillData?.weigh_bridge_ticket_reference_no ||
        index,
      weighbridge_ticket_id: backendTicketId || prefillData?.weighbridge_ticket_id || "",

      raw: item,

      weigh_bridge_ticket_number: prefillData?.weigh_bridge_ticket_number || "",
      ticket_number: prefillData?.weigh_bridge_ticket_number || "",
      weigh_bridge_ticket_reference_no: prefillData?.weigh_bridge_ticket_reference_no || "",
      external_weigh_bridge_ticket_number: prefillData?.external_weigh_bridge_ticket_number || "",

      first_weight: prefillData?.first_weight || "",
      second_weight: prefillData?.second_weight || "",
      net_weight: prefillData?.net_weight || "",

      time_in: ticket?.time_in || prefillData?.time_in || "",
      time_out: ticket?.time_out || prefillData?.time_out || "",
      created_on: ticket?.created_on || prefillData?.created_on || "",

      truck_driver_name: prefillData?.truck_driver_name || "",
      transporter_name: prefillData?.transporter_name || "",
      truck_licence_plate: prefillData?.truck_licence_plate || "",
      vehicle_number: prefillData?.truck_licence_plate || "",

      designation: prefillData?.designation || "",
      usage_status: prefillData?.usage_status || resolveWeighbridgeUsageStatus(item),

      weigh_bridge_ticket_status_id:
        prefillData?.weigh_bridge_ticket_status_id ||
        ticket?.weigh_bridge_ticket_status_id ||
        item?.weigh_bridge_ticket_status_id ||
        ticketStatus?.weigh_bridge_ticket_status_id ||
        "",
      weigh_bridge_ticket_status:
        prefillData?.weigh_bridge_ticket_status ||
        ticketStatus?.weigh_bridge_ticket_status ||
        ticket?.weigh_bridge_ticket_status ||
        (typeof item?.weigh_bridge_ticket_status === "string"
          ? item.weigh_bridge_ticket_status
          : "") ||
        "",

      weigh_bridge_ticket_type_id:
        prefillData?.weigh_bridge_ticket_type_id ||
        ticket?.weigh_bridge_ticket_type_id ||
        item?.weigh_bridge_ticket_type_id ||
        ticketType?.weigh_bridge_ticket_type_id ||
        "",
      weigh_bridge_ticket_type:
        prefillData?.weigh_bridge_ticket_type ||
        ticketType?.weigh_bride_ticket_type ||
        ticketType?.weigh_bridge_ticket_type ||
        ticket?.weigh_bridge_ticket_type ||
        (typeof item?.weigh_bridge_ticket_type === "string"
          ? item.weigh_bridge_ticket_type
          : "") ||
        "",
    };
  });
};

const normalizeDnSelectedTicket = (ticket = null) => {
  if (!ticket) {
    return null;
  }

  const selectedTicketPrefill = resolveWeighbridgeTicketPrefillData(ticket);

  return {
    ...ticket,
    ...selectedTicketPrefill,
    first_weight:
      ticket?.first_weight ||
      selectedTicketPrefill?.first_weight ||
      "",
    second_weight:
      ticket?.second_weight ||
      selectedTicketPrefill?.second_weight ||
      "",
    net_weight:
      ticket?.net_weight ||
      selectedTicketPrefill?.net_weight ||
      "",
    id: ticket?.id || selectedTicketPrefill?.weighbridge_ticket_id || "",
    raw: ticket?.raw || ticket,
  };
};

const flattenBranchGroupedTickets = (rows = []) =>
  rows.flatMap((item) => {
    const nestedTickets = Array.isArray(item?.weigh_bridge_tickets)
      ? item.weigh_bridge_tickets
      : Array.isArray(item?.weighbridge_tickets)
        ? item.weighbridge_tickets
        : Array.isArray(item?.tickets)
          ? item.tickets
          : [];

    if (!nestedTickets.length) {
      if (item?.tickets && typeof item.tickets === "object" && !Array.isArray(item.tickets)) {
        return [
          {
            ...item.tickets,
            raw: item,
            branch_location_id:
              item?.tickets?.branch_location_id || item?.branch_location_id || "",
            branch_area: item?.tickets?.branch_area || item?.branch_area || "",
            province_id: item?.tickets?.province_id || item?.province_id || "",
            province_name: item?.tickets?.province_name || item?.province_name || "",
          },
        ];
      }

      return [item];
    }

    return nestedTickets.map((ticketRow) => ({
      ...ticketRow,
      branch_location_id:
        ticketRow?.branch_location_id || item?.branch_location_id || "",
      branch_area: ticketRow?.branch_area || item?.branch_area || "",
      province_id: ticketRow?.province_id || item?.province_id || "",
      province_name: ticketRow?.province_name || item?.province_name || "",
    }));
  });

const looksLikeTicketGroupRow = (item = {}) =>
  Boolean(
    Array.isArray(item?.weigh_bridge_tickets) ||
      Array.isArray(item?.weighbridge_tickets) ||
      Array.isArray(item?.tickets),
  );

const looksLikeTicketRow = (item = {}) =>
  Boolean(
    item?.ticket ||
      item?.tickets ||
      looksLikeTicketGroupRow(item) ||
      item?.weigh_bridge_ticket ||
      item?.weighbridge_ticket ||
      item?.weigh_bridge_ticket_number ||
      item?.weigh_bridge_ticket_reference_no ||
      item?.external_weigh_bridge_ticket_number,
  );

const getTicketArrayCandidateScore = (path = "") => {
  const normalizedPath = String(path || "")
    .trim()
    .replaceAll(/[.[\]]+/g, " ")
    .replace(/\s+/g, " ")
    .toLowerCase();

  if (!normalizedPath) {
    return 0;
  }

  let score = 0;

  if (normalizedPath.includes("not set")) score += 12;
  if (normalizedPath.includes("unattached")) score += 10;
  if (normalizedPath.includes("available")) score += 8;
  if (normalizedPath.includes("eligible")) score += 8;
  if (normalizedPath.includes("unassigned")) score += 7;
  if (normalizedPath.includes("unused")) score += 7;
  if (normalizedPath.includes("ticket")) score += 3;
  if (normalizedPath.includes("weigh")) score += 2;

  if (normalizedPath.includes("designated")) score -= 9;
  if (normalizedPath.includes("attached")) score -= 8;
  if (normalizedPath.includes("used")) score -= 8;
  if (normalizedPath.includes("processed")) score -= 6;
  if (normalizedPath.includes("goods received")) score -= 4;
  if (normalizedPath.includes("delivery note")) score -= 4;

  return score;
};

const isTicketCollection = (items = []) =>
  Array.isArray(items) &&
  items.some((item) => looksLikeTicketRow(item) || looksLikeTicketGroupRow(item));

const extractTicketList = (responseData) => {
  const queue = [{ value: responseData, path: "root" }];
  const visited = new Set();
  let fallbackRows = [];
  let fallbackPath = "root";
  let bestCandidate = null;

  while (queue.length > 0) {
    const { value: current, path } = queue.shift();

    if (!current || visited.has(current)) {
      continue;
    }

    if (typeof current === "object") {
      visited.add(current);
    }

    if (Array.isArray(current)) {
      if (isTicketCollection(current)) {
        const normalizedRows = flattenBranchGroupedTickets(current);
        const candidateScore = getTicketArrayCandidateScore(path);

        if (!fallbackRows.length) {
          fallbackRows = normalizedRows;
          fallbackPath = path;
        }

        if (!bestCandidate || candidateScore > bestCandidate.score) {
          bestCandidate = {
            rows: normalizedRows,
            path,
            score: candidateScore,
          };
        }
      }

      current.forEach((item, index) => {
        if (item && typeof item === "object") {
          queue.push({ value: item, path: `${path}[${index}]` });
        }
      });
      continue;
    }

    if (typeof current !== "object") {
      continue;
    }

    const arrayCandidateEntries = [
      ["weigh_bridge_tickets", current?.weigh_bridge_tickets],
      ["weighbridge_tickets", current?.weighbridge_tickets],
      ["tickets", current?.tickets],
      ["rows", current?.rows],
      ["items", current?.items],
      ["data", current?.data],
    ];

    for (const [candidateKey, candidate] of arrayCandidateEntries) {
      if (Array.isArray(candidate) && candidate.length > 0) {
        const candidatePath = `${path}.${candidateKey}`;

        if (isTicketCollection(candidate)) {
          const normalizedRows = flattenBranchGroupedTickets(candidate);
          const candidateScore = getTicketArrayCandidateScore(candidatePath);

          if (!fallbackRows.length) {
            fallbackRows = normalizedRows;
            fallbackPath = candidatePath;
          }

          if (!bestCandidate || candidateScore > bestCandidate.score) {
            bestCandidate = {
              rows: normalizedRows,
              path: candidatePath,
              score: candidateScore,
            };
          }
        }

        queue.push({ value: candidate, path: candidatePath });
      }
    }

    [
      ["data", current?.data],
      ["payload", current?.payload],
      ["result", current?.result],
      ["context", current?.context],
      ["weigh_bridge_tickets_data", current?.weigh_bridge_tickets_data],
    ].forEach(([candidateKey, candidate]) => {
      if (candidate && typeof candidate === "object") {
        queue.push({ value: candidate, path: `${path}.${candidateKey}` });
      }
    });
  }

  if (bestCandidate?.rows?.length) {
    return bestCandidate;
  }

  return {
    rows: fallbackRows,
    path: fallbackRows.length ? fallbackPath : "",
    score: fallbackRows.length ? getTicketArrayCandidateScore(fallbackPath) : Number.NEGATIVE_INFINITY,
  };
};

const formatLastWeighbridgeSyncLabel = (syncMeta) => {
  if (!syncMeta?.syncedAt) {
    return "Last synced: Not yet";
  }

  const formattedTime = new Date(syncMeta.syncedAt).toLocaleString();
  const importedCountText =
    typeof syncMeta?.importedCount === "number"
      ? `, ${syncMeta.importedCount} ticket${syncMeta.importedCount === 1 ? "" : "s"} imported`
      : "";

  return `Last synced: ${formattedTime}${importedCountText}`;
};

const SHOULD_DEBUG_WEIGHBRIDGE = process.env.REACT_APP_DEBUG_WEIGHBRIDGE === "true";
const WEIGHBRIDGE_TICKET_CACHE_TTL_MS = 60 * 1000;

let deliveryNoteWeighbridgeTicketCache = {
  updatedAt: 0,
  tickets: [],
};

const isTicketCacheFresh = (updatedAt = 0) =>
  updatedAt > 0 && Date.now() - updatedAt < WEIGHBRIDGE_TICKET_CACHE_TTL_MS;

const getReadableDnTicketText = (value = "") =>
  String(value || "")
    .trim()
    .replaceAll("_", " ")
    .replace(/\s+/g, " ");

const getDnWeighbridgeIneligibilityReason = (ticket = {}) => {
  if (String(ticket?.usage_status || "").toUpperCase() === "USED") {
    return "Already linked";
  }

  const ticketPrefill = resolveWeighbridgeTicketPrefillData(ticket);
  const resolvedFirstWeight = ticket?.first_weight || ticketPrefill?.first_weight || "";

  if (!resolvedFirstWeight) {
    return "Missing tare weight";
  }

  return "";
};

const isSelectableDnWeighbridgeTicket = (ticket = {}) =>
  !getDnWeighbridgeIneligibilityReason(ticket);

const getDnTicketReferenceNo = (ticket = {}) =>
  ticket?.weigh_bridge_ticket_reference_no ||
  ticket?.ticket?.weigh_bridge_ticket_reference_no ||
  ticket?.raw?.ticket?.weigh_bridge_ticket_reference_no ||
  ticket?.raw?.weigh_bridge_ticket_reference_no ||
  "";

const extractDnTicketDetails = (responseData) => {
  const payload = responseData?.data || responseData || {};
  return payload?.Weighbridge_ticket || payload?.weighbridge_ticket || payload?.weigh_bridge_ticket || payload;
};

const CreateDeliveryNote = ({ page_type }) => {
  const dispatch = useDispatch();
  const { delivery_note_ref_number } = useParams();
  const location = useLocation();
  const [page] = useState(page_type);
  const preselectedWeighbridgeTicket = location?.state?.selectedWeighbridgeTicket || null;
  const normalizedPreselectedWeighbridgeTicket = preselectedWeighbridgeTicket
    ? normalizeDnSelectedTicket(preselectedWeighbridgeTicket)
    : null;

  const [showWeighbridgeModal, setShowWeighbridgeModal] = useState(false);
  const [selectedWeighbridgeTicket, setSelectedWeighbridgeTicket] = useState(normalizedPreselectedWeighbridgeTicket);
  const [weighbridgeTickets, setWeighbridgeTickets] = useState([]);
  const [loadingWeighbridgeTickets, setLoadingWeighbridgeTickets] = useState(false);
  const [weighbridgeError, setWeighbridgeError] = useState("");
  const [lastWeighbridgeSyncLabel, setLastWeighbridgeSyncLabel] = useState(
    formatLastWeighbridgeSyncLabel(getLastWeighbridgeSyncMeta()),
  );
  const inFlightWeighbridgeRequestRef = useRef(null);

  const isCreateMode = !delivery_note_ref_number;
  const resolvedSelectedWeighbridgeTicket = useMemo(
    () => normalizeDnSelectedTicket(selectedWeighbridgeTicket),
    [selectedWeighbridgeTicket],
  );

  const loadWeighbridgeTickets = useCallback(async ({ silent = false, forceRefresh = false } = {}) => {
    const cachedTickets = deliveryNoteWeighbridgeTicketCache.tickets || [];
    const hasCachedTickets = cachedTickets.length > 0;
    const cacheIsFresh = hasCachedTickets && isTicketCacheFresh(deliveryNoteWeighbridgeTicketCache.updatedAt);

    if (hasCachedTickets) {
      setWeighbridgeTickets(cachedTickets);
    }

    if (!forceRefresh && cacheIsFresh) {
      setWeighbridgeError("");
      setLoadingWeighbridgeTickets(false);
      return;
    }

    if (inFlightWeighbridgeRequestRef.current) {
      if (!silent) {
        setLoadingWeighbridgeTickets(true);
      }

      try {
        const cachedPayload = await inFlightWeighbridgeRequestRef.current;
        setWeighbridgeError("");
        setWeighbridgeTickets(cachedPayload.tickets);
      } catch (error) {
        if (!hasCachedTickets) {
          setWeighbridgeError(
            error?.response?.data?.message || "Failed to retrieve weighbridge tickets.",
          );
          setWeighbridgeTickets([]);
        }
      } finally {
        if (!silent || !hasCachedTickets) {
          setLoadingWeighbridgeTickets(false);
        }
      }
      return;
    }

    try {
      if (!silent || !hasCachedTickets) {
        setLoadingWeighbridgeTickets(true);
      }
      setWeighbridgeError("");

      inFlightWeighbridgeRequestRef.current = (async () => {
        const response = await makeEmployeeDashboardApiRequest("get", RETRIEVE_ALL_WEIGH_BRIDGE_TICKETS_API);

        const responseData = response?.data?.data || response?.data || [];
        const { rows, path: ticketSourcePath } = extractTicketList(responseData);

        const normalized = sortWeighbridgeTicketsDesc(normalizeWeighbridgeTickets(rows));

        deliveryNoteWeighbridgeTicketCache = {
          updatedAt: Date.now(),
          tickets: normalized,
        };

        if (SHOULD_DEBUG_WEIGHBRIDGE) {
          console.log("DN WEIGHBRIDGE RAW RESPONSE =>", response?.data);
          console.log("DN WEIGHBRIDGE TICKET SOURCE PATH =>", ticketSourcePath || "not found");
          console.log("DN WEIGHBRIDGE FIRST ROW =>", rows?.[0] || null);
          console.log("DN WEIGHBRIDGE FIRST NORMALIZED ROW =>", normalized?.[0] || null);
        }

        return {
          tickets: normalized,
        };
      })();

      const nextPayload = await inFlightWeighbridgeRequestRef.current;
      setWeighbridgeTickets(nextPayload.tickets);
    } catch (error) {
      console.error("Retrieve weighbridge tickets error =>", error);
      if (error?.response?.status === 401) {
        dispatch(success_sign_out_modal());
      }
      if (!hasCachedTickets) {
        setWeighbridgeError(error?.response?.data?.message || "Failed to retrieve weighbridge tickets.");
        setWeighbridgeTickets([]);
      } else {
        setWeighbridgeError("Showing cached tickets while the latest refresh failed.");
      }
    } finally {
      inFlightWeighbridgeRequestRef.current = null;
      if (!silent || !hasCachedTickets) {
        setLoadingWeighbridgeTickets(false);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    if (!isCreateMode) {
      return;
    }

    void loadWeighbridgeTickets({ silent: true });
  }, [isCreateMode, loadWeighbridgeTickets]);

  const openWeighbridgeModal = useCallback(async () => {
    setLastWeighbridgeSyncLabel(formatLastWeighbridgeSyncLabel(getLastWeighbridgeSyncMeta()));
    setShowWeighbridgeModal(true);
    void loadWeighbridgeTickets();
  }, [loadWeighbridgeTickets]);

  const refreshWeighbridgeTickets = useCallback(() => {
    setLastWeighbridgeSyncLabel(formatLastWeighbridgeSyncLabel(getLastWeighbridgeSyncMeta()));
    void loadWeighbridgeTickets({ forceRefresh: true });
  }, [loadWeighbridgeTickets]);

  const closeWeighbridgeModal = useCallback(() => {
    setShowWeighbridgeModal(false);
  }, []);

  const handleSelectWeighbridgeTicket = useCallback(async (ticket) => {
    if (!isSelectableDnWeighbridgeTicket(ticket)) {
      return;
    }

    const normalizedTicket = normalizeDnSelectedTicket(ticket);
    const hasResolvedWeights =
      normalizedTicket?.first_weight &&
      normalizedTicket?.second_weight &&
      normalizedTicket?.net_weight;

    if (hasResolvedWeights) {
      setSelectedWeighbridgeTicket(normalizedTicket);
      setShowWeighbridgeModal(false);
      return;
    }

    const referenceNo = getDnTicketReferenceNo(ticket);

    if (!referenceNo) {
      setSelectedWeighbridgeTicket(normalizedTicket);
      setShowWeighbridgeModal(false);
      return;
    }

    try {
      setLoadingWeighbridgeTickets(true);
      const response = await makeEmployeeDashboardApiRequest(
        "get",
        RETRIEVE_WEIGH_BRIDGE_TICKET_DETAILS_API(referenceNo),
      );
      const ticketDetails = extractDnTicketDetails(response?.data);
      setSelectedWeighbridgeTicket(
        normalizeDnSelectedTicket({
          ...normalizedTicket,
          ...ticketDetails,
          raw: ticketDetails || normalizedTicket?.raw || ticket,
        }),
      );
    } catch (error) {
      console.error("Retrieve DN weighbridge ticket details error =>", error);
      setSelectedWeighbridgeTicket(normalizedTicket);
    } finally {
      setLoadingWeighbridgeTickets(false);
      setShowWeighbridgeModal(false);
    }
  }, []);

  const pageTitle =
    page === app_consts.CREATE_PHYSICAL_DELIVERY_NOTE_TICKET
      ? `${delivery_note_ref_number ? "Continue Processing" : "Create"} Physical Delivery Note`
      : `${delivery_note_ref_number ? "Continue Processing" : "Create"} Physical Delivery Note`;

  return (
    <>
      <Head title={pageTitle} />

      <Content>
        <PageHeading
          title={pageTitle}
          title_addition={delivery_note_ref_number}
          description={
            page === app_consts.CREATE_PHYSICAL_DELIVERY_NOTE_TICKET
              ? "Process a Physical Delivery Note Ticket from your Designated Warehouse."
              : "Process a Physical Delivery Note Ticket from your Designated Warehouse."
          }
          backToText={`${
            delivery_note_ref_number ? `${delivery_note_ref_number} Ticket Details` : "Delivery Note Tickets"
          }`}
          backToLink={`/dashboard/delivery_notes${delivery_note_ref_number ? `/${delivery_note_ref_number}` : ""}`}
        />

        {isCreateMode && (
          <div className="mb-3">
            <Button color="primary" onClick={openWeighbridgeModal}>
              {resolvedSelectedWeighbridgeTicket ? "Change Weighbridge Ticket" : "Select Weighbridge Ticket"}
            </Button>

            {resolvedSelectedWeighbridgeTicket && (
              <SelectedWeighbridgeTicketCard
                ticket={resolvedSelectedWeighbridgeTicket}
                flowLabel="delivery note flow"
                onChangeTicket={openWeighbridgeModal}
              />
            )}
          </div>
        )}

        <WizardComp type={page} selectedWeighbridgeTicket={resolvedSelectedWeighbridgeTicket} />
      </Content>

      <Modal isOpen={showWeighbridgeModal} toggle={closeWeighbridgeModal} size="xl" fullscreen>
        <ModalHeader toggle={closeWeighbridgeModal}>Select Weighbridge Ticket</ModalHeader>
        <ModalBody>
          <div className="text-soft small mb-3">{lastWeighbridgeSyncLabel}</div>

          {loadingWeighbridgeTickets && weighbridgeTickets.length === 0 ? (
            <AuthLoader loading_message="Loading weighbridge tickets..." />
          ) : weighbridgeError && weighbridgeTickets.length === 0 ? (
            <Alert color="danger" className="mb-0">
              {weighbridgeError}
            </Alert>
          ) : (
            <>
              {loadingWeighbridgeTickets && weighbridgeTickets.length > 0 && (
                <div className="text-soft small mb-3">Refreshing weighbridge tickets...</div>
              )}
              {weighbridgeError && weighbridgeTickets.length > 0 && (
                <Alert color="warning" className="mb-3">
                  {weighbridgeError}
                </Alert>
              )}
              <WeighbridgeTicketSelector
                tickets={weighbridgeTickets}
                allTickets={weighbridgeTickets}
                onSelect={handleSelectWeighbridgeTicket}
                onClose={closeWeighbridgeModal}
                onRefresh={refreshWeighbridgeTickets}
                isRefreshing={loadingWeighbridgeTickets}
                isSelectableTicket={isSelectableDnWeighbridgeTicket}
                getDisabledActionLabel={(ticket) => getDnWeighbridgeIneligibilityReason(ticket) || "Not Eligible"}
                getSelectionStatusLabel={(ticket) =>
                  isSelectableDnWeighbridgeTicket(ticket)
                    ? "Eligible"
                    : getDnWeighbridgeIneligibilityReason(ticket) || "Not Eligible"
                }
                getSelectionStatusTone={(ticket) =>
                  isSelectableDnWeighbridgeTicket(ticket) ? "success" : "warning"
                }
              />
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateDeliveryNote;
